import ColorThemeAwareDiagram from './color-theme-aware-diagram.js'

export default class AnalysisChart extends ColorThemeAwareDiagram {

  constructor() {
    super();
    this.chartOptions = {
      scales: {
        y: {
          type: 'linear',
          position: 'left',
          beginAtZero: true,
          title: {
            display: true,
            text: window.I18n.t('js.chart.activity'),
            color: _ => this.textColor,
            font: _ => this.fontFamily
          },
          grid: {
            color: 'rgba(120,120,120,0.2)',
            drawTicks: true
          },
          ticks: {
            color: _ => this.textColor,
            width: 1,
            min: 0
          }
        }
      },
      responsive: true,
      maintainAspectRatio: false,
      plugins: {
        legend: {
          display: true,
          labels: {
            color: _ => this.textColor
          }
        }
      }
    }
  }

  connect() {
    this.xAxis  = this.querySelector('chart-filter .x-axis');
    this.zAxis  = this.querySelector('chart-filter .z-axis');

    if (this.canvas && this.xAxis && this.zAxis) {
      this.observationData = this.querySelector('observation-data');
      this.initChart();
      this.xAxis.addEventListener('change', this.initChart.bind(this), false);
      this.zAxis.addEventListener('change', this.initChart.bind(this), false);
    }
  }

  initChart() {
    if (this.chart) {
      this.chart.destroy();
    }
    let chartLabels    = [];
    let allUniqueDates = [];
    let speciesRawData = {};
    let xSelector = `.${this.xAxis.value}`;
    let zSelector = `.${this.zAxis.value}`;

    this.observationData.querySelectorAll('.dataset').forEach((elem) => {
      let zAxisName = elem.querySelector(zSelector).innerHTML.replace(/^\s+|\s+$/g, '');
      let xAxisName = elem.querySelector(xSelector).innerHTML.replace(/^\s+|\s+$/g, '');
      let observationQuantity = parseInt(elem.querySelector('.quantity').innerHTML);
      if (observationQuantity > 0) {
        if (!speciesRawData[zAxisName]) {
          speciesRawData[zAxisName] = {};
        }

        if (!speciesRawData[zAxisName][xAxisName]) {
          speciesRawData[zAxisName][xAxisName] = 0;
        }

        speciesRawData[zAxisName][xAxisName] += observationQuantity;

        allUniqueDates.push(xAxisName);
      }
    });

    let yData = Object.keys(speciesRawData).sort().map((key, i) => {
      let colour = this.graphColors[i];

      return {
        backgroundColor:      `rgba(${colour},0.5)`,
        borderColor:          `rgba(${colour},0.8)`,
        hoverBackgroundColor: `rgba(${colour},0.9)`,
        hoverBorderColor:     `rgba(${colour},1)`,
        label: key,
        type: 'bar',
        multiTooltipTemplate: "<%=value%> <%=datasetLabel%>",
        data: []
      }
    });

    allUniqueDates = this.unique(allUniqueDates.sort());
    Array.prototype.forEach.call(allUniqueDates, (currentDate, idx) => {
      chartLabels[idx] = currentDate;
      yData.forEach(specDat => {
        specDat.data[idx] = speciesRawData[specDat.label][currentDate] || 0;
      });
    });

    let chartData = {
      labels: chartLabels,
      datasets: []
    };

    Array.prototype.forEach.call(yData, (obj, idx) => {
      chartData.datasets[idx] = obj;
    });

    this.buildChart('bar', chartData, this.chartOptions);
  }

  unique(array) {
    return array.filter(function(el, index, arr) {
      return index === arr.indexOf(el);
    });
  }
}

customElements.define('analysis-chart', AnalysisChart);
